// extracted by mini-css-extract-plugin
export var addButton = "_dm-0";
export var border = "_dm-8";
export var check = "_dm-h";
export var danger = "_dm-6";
export var dropdownContainer = "_dm-1";
export var editModalBody = "_dm-j";
export var footerContainer = "_dm-i";
export var fullWidth = "_dm-a";
export var hide = "_dm-9";
export var icon = "_dm-3";
export var input = "_dm-7";
export var inputFlex = "_dm-b";
export var inputWrapper = "_dm-c";
export var manualFocus = "_dm-5";
export var optionButton = "_dm-4";
export var pillWrapper = "_dm-e";
export var pointer = "_dm-2";
export var showOverflow = "_dm-f";
export var tagsFlex = "_dm-d";
export var xButton = "_dm-g";